import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_home",
  "use": "icon_home-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 48 48\" id=\"icon_home\"><path fill=\"currentColor\" d=\"M24 4a3 3 0 012.178.937L34 13.194V13a3 3 0 116 0v6.527l4.178 4.41a3 3 0 01-4.356 4.126L24 11.363l-15.822 16.7a3 3 0 11-4.356-4.126l18-19A3 3 0 0124 4z\" /><path fill=\"currentColor\" d=\"M9.5 28.849V36a8.5 8.5 0 008.5 8.5h12a8.5 8.5 0 008.5-8.5v-7.151l-5-5.278V36a3.5 3.5 0 01-3.5 3.5H18a3.5 3.5 0 01-3.5-3.5V23.57l-5 5.279z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol